import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import ContentsModal from 'contents_modal';

import Const         from 'fw_const';
import Utils         from 'utils';
// -------------------------------------------------------

class ReportScore extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.score = {};
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal_url : null,
      edit_mode : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの表示非表示
   */
  toggleModal(flg) {
    this.setState({ modal_url: flg });
  }
  // -------------------------------------------------------
  
  /*
   * 編集モードの変更
   */
  toggleEditMode() {
    this.setState({ edit_mode: (this.state.edit_mode == true) ? false : true });
  }
  // -------------------------------------------------------
  
  /*
   * スコアの保存
   */
  saveAction() {
    let report = this.props.detail.report;
    
    let update = {};
    for( let i in this.score ) update[i] = this.score[i].value;
    
    Utils.request.bind(this)('/api/influencer/save_report_score', { insta_user_id: report.insta_user_id, report_id: report.id, project_id: report.project_id, update: update },
      function(res){
        this.props.base.event.updateData('report', res.body.report);
        this.setState({ edit_mode: false });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let report = this.props.detail.report;
    
    let insight = [];
    
    if( report.product_type == 'FEED' ){
      insight = [
        { id: 'insight1', columns: ['likes', 'comments', 'dm_message', 'saved'] },
        { id: 'insight2', columns: ['reach', 'impressions', 'score_home', 'score_discovery', 'score_profile', 'score_tag', 'score_etc'] },
        { id: 'insight3', columns: ['share', 'profile_active', 'profile_exlink', 'profile_access', 'profile_follow'] },
      ];
    }
    if( report.product_type == 'REELS' ){
      insight = [
        { id: 'insight1', columns: ['plays', 'likes', 'comments', 'dm_message', 'saved'] },
        { id: 'insight2', columns: ['first_plays', 'replay'] },
        { id: 'insight3', columns: ['share', 'profile_active', 'profile_exlink', 'profile_access', 'profile_follow'] },
      ];
    }
    if( report.product_type == 'STORY' ){
      insight = [
        { id: 'insight1', columns: ['reach', 'action_account', 'action_profile', 'action_interaction'] },
        { id: 'insight2', columns: ['likes', 'link_clicks', 'total_action', 'profile_active', 'profile_exlink', 'profile_access', 'profile_follow'] },
      ];
    }
    
    return (
      <div className="modal-item report-score">
        { (this.props.report_edit !== false) &&
          <div className="report-insight-header">
            { (report.is_insight_update !== 1)
              ? <p className="report-help"><i className="material-icons">info</i>レポートの数値を確認しましょう</p>
              : <p className="report-help done"><i className="material-icons">check_circle</i>レポートの数値を確認しました</p>
            }
            
            { (this.state.edit_mode == true)
              ? <p className="button mini cancel" onClick={this.toggleEditMode.bind(this)}>キャンセル</p>
              : <p className="button mini" onClick={this.toggleEditMode.bind(this)}>数値の編集</p>
            }
            
            { (this.state.edit_mode == true) && <p className="button mini save" onClick={this.saveAction.bind(this)}>保存</p> }
            
            <p className="insight">インサイト</p>
          </div>
        }
        
        { insight.map((d, key) => {
          let file_url = '';
          try { report.insight.map((m) => { if( m.file_id == d.id ) file_url = m.file_url; }); } catch(e) {}
          
          return (
            <div key={key} className={'report-insight-contents '+ d.id}>
              <div className="insight-item-contents">
                { d.columns.map((cid, ckey) => {
                  let name = Const.value.insight_score[cid];
                  let value = report[cid];
                  if( value == undefined || value == null ) value = 0;
                  
                  return (
                    <div key={ckey} className="insight-item">
                      <h6>{name}</h6>
                      { (this.state.edit_mode == true)
                        ? <input className="text" type="text" ref={(input) => { this.score[cid] = input }} placeholder={name} defaultValue={value} />
                        : <h3>{Utils.viewInt(value)}</h3>
                      }
                    </div>
                  );
                })}
              </div>
              
              { (this.props.report_edit !== false) &&
                <img src={file_url} onClick={this.toggleModal.bind(this, file_url)} />
              }
            </div>
          );
        })}
        
        { (this.state.modal_url != null) &&
          <ContentsModal
            view      = {true}
            width     = {'400px'}
            height    = {'calc(100% - 60px)'}
            close_ev  = {this.toggleModal.bind(this, null)}
            html      = {<img className="report-insight-image" src={this.state.modal_url} />}
          />
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportScore;